import { useGenerateAiSurveyMutation } from "../redux/ai/ai.endpoints";
import { useEffect, useState } from "react";
import { SurveyStatus } from "../redux/survey/survey.types";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GenerateSurveyFormValues } from "../pages/generate-survey/generate-survey.types";
import { showNotification } from "../redux/notification/notification.slice";
import FirebaseService from "../services/firebase/firebase.service";
import { setSurveyConfidenceToggle } from "../redux/survey/survey-targeting-toggle.slice";
import ErrorLogService from "src/services/error-log/error-log.service";
import { RootState } from "src/redux/redux-store";

const useGenerateSurvey = () => {
  const confidenceConfig = FirebaseService.getRemoteConfigBool('SURVEYS_DEFAULT_CONFIDENCE');
  const [generateAiSurvey, { data: generatedSurvey, isError: isGenerationError }] = useGenerateAiSurveyMutation();
  const [isGenerating, setIsGenerating] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const activeClient = useSelector((state: RootState) => state.userState.activeClient);

  useEffect(() => {
    isGenerationError && setIsGenerating(false);
  }, [isGenerationError]);

  useEffect(() => {
    if (!generatedSurvey) {
      return;
    }

    dispatch(setSurveyConfidenceToggle({ surveyId: generatedSurvey.extSurveyId, isUsingConfidenceInterval: confidenceConfig }));
    if (activeClient && generatedSurvey.surveyStatus === SurveyStatus.Draft) {
      navigate(`/client/${activeClient.ext_client_id}/surveys/create?ext-survey-id=${generatedSurvey.extSurveyId}`);
    } else if (generatedSurvey.surveyStatus === SurveyStatus.Draft) {
      navigate(`/surveys/create?ext-survey-id=${generatedSurvey.extSurveyId}`);
    }

    if (generatedSurvey?.surveyStatus === SurveyStatus.Failed) {
      dispatch(showNotification({ theme: 'warning', summary: 'Something went wrong. Please try again.' }));
      ErrorLogService.logError('Generation error', 'useGenerateSurvey', 'useEffect-generatedSurvey');
      setIsGenerating(false);
    }
  }, [generatedSurvey]);

  const createSurvey = async(template_id: string, data: GenerateSurveyFormValues) => {
    setIsGenerating(true);
    void generateAiSurvey({ template_id, formData: data });
  };

  return { generateSurvey: createSurvey, isGenerating, isRetrying: generatedSurvey?.surveyStatus === SurveyStatus.Retry };
};

export default useGenerateSurvey;
